import * as Yup from 'yup';

interface IErrors {
  required: string;
  maxLength: string;
  noSpaces: string;
  duplicate: string;
  invalidCharacter: string;
}

function validationSchema(errors: IErrors, existingNames: string[]) {
  return Yup.object().shape({
    name: Yup.string()
      .min(1, errors.required)
      .max(100, errors.maxLength.replace('{max}', '100'))
      .matches(/^\S+$/, errors.noSpaces)
      // @ts-ignore
      .matches(/^[\p{L}\p{M}\p{N}_]+$/u, errors.invalidCharacter)
      .notOneOf(existingNames, errors.duplicate)
      .required(errors.required),
  });
}

export const validationTagName = (
  val: any,
  errors: IErrors,
  existingNames: string[] = []
): string | undefined => {
  const value = { name: val };

  const schema = validationSchema(errors, existingNames);

  try {
    schema.validateSync(value, { abortEarly: false });
    return undefined;
  } catch (error: any) {
    return error.inner[0].errors[0];
  }
};
